var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"section_politica containerg"},[_c('div',{staticClass:"title_politica"},[_vm._v(_vm._s(_vm.$t('faq_support')))]),_c('div',{staticClass:"container_politica"},[_vm._v(" Urmeaza ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }